import { render, staticRenderFns } from "./SuggestionCard.vue?vue&type=template&id=58fb9fcc&scoped=true"
import script from "./SuggestionCard.vue?vue&type=script&lang=ts"
export * from "./SuggestionCard.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionCard.vue?vue&type=style&index=0&id=58fb9fcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb9fcc",
  null
  
)

export default component.exports